'use client';

import { useClientTranslation } from '@bts-web/utils-lokalise';
import { ButtonBase } from '../../ButtonBase/ButtonBase';
import { useRouter } from 'next/navigation';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { ButtonComponentProps } from '../../../types/components';

type GoToPortfolioButtonProps = {
  fullWidth?: ButtonComponentProps['fullWidth'];
  size?: ButtonComponentProps['size'];
};

const GoToPortfolioButton = (props: GoToPortfolioButtonProps) => {
  const { t } = useClientTranslation();

  const router = useRouter();

  return (
    <ButtonBase onClick={() => router.push(NEXT_ROUTES.PORTFOLIO)} {...props}>
      {t('go_to_portfolio')}
    </ButtonBase>
  );
};

export { GoToPortfolioButton };
